import React from "react";
import BulkUploadWizard from "./BulkUploadWizard";
import BulkUploadSetsPage from "./BulkUploadSetsPage";

export const LeadsBulkUploadPage: React.FC = () => (
  <BulkUploadWizard defaultType="leads" />
);

export const LeadsBulkUploadSetsPage: React.FC = () => (
  <BulkUploadSetsPage defaultType="leads" />
);

export const CpBulkUploadPage: React.FC = () => (
  <BulkUploadWizard defaultType="channel_partners" />
);

export const CpBulkUploadSetsPage: React.FC = () => (
  <BulkUploadSetsPage defaultType="channel_partners" />
);

export const CallDatasetUploadPage: React.FC = () => (
  <BulkUploadWizard defaultType="call_dataset" />
);
